<template>
    <div class="_block">
        <el-pagination :current-page="Number(currentPage)" :page-size='Number(pageSize)'
                       :page-sizes="pageSizes"
                       :total="Number(totalNumber)" layout="total, sizes, prev, pager, next, jumper"
                       @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
</template>

<script>
export default {
    props: {
        totalNumber: {
            type: [Number, String],
            default: 0
        },
        pageSizes: {
            type: Array,
            default: () => {
                return [20, 40, 60, 80]
            }
        },
        //当前的页数
        currentPage: {
            type: [Number, String],
            default: 1
        },
        parentPageSize: {
            type: [Number, String],
            default: 10,
        }
    },
    data() {
        return {
            perPage: 1,
            pageSize: this.parentPageSize,
        }
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val
            this.$emit("loadTable", this.perPage, this.pageSize);
        },
        handleCurrentChange(val) {
            this.perPage = val
            this.$emit("loadTable", this.perPage, this.pageSize);
        },
    }
}
</script>
<style lang="scss" scoped>
._block /deep/ .el-pagination {
    display: flex;
    justify-content: center;
}
</style>